(function () {
  const TRUCK_IMAGE_BASE =
    'https://cdn.shopify.com/s/files/1/0712/1131/9389/files/';
  const DEFAULT_TRUCK_IMAGE = `${TRUCK_IMAGE_BASE}td-drawer-select-truck.png?v=1781037088`;

  const MAKE_LABELS = {
    ford: 'FORD',
    gm: 'GM',
    ram: 'RAM',
    jeep: 'JEEP',
    benz: 'MERCEDES BENZ',
    nissan: 'NISSAN',
  };

  const MAKE_LOGOS = {
    ford: `${TRUCK_IMAGE_BASE}ford-white-logo.png?v=1783464202`,
    gm: `${TRUCK_IMAGE_BASE}gm-white-logo.png?v=1783464202`,
    ram: `${TRUCK_IMAGE_BASE}ram-white-logo.png?v=1783464202`,
    jeep: `${TRUCK_IMAGE_BASE}jeep-white-logo.png?v=1783466714`,
    nissan: `${TRUCK_IMAGE_BASE}nissan-white-logo.png?v=1783464202`,
    benz: `${TRUCK_IMAGE_BASE}benz-white-logo.png?v=1783464202`,
  };

  // Body styles shown after the vehicle in the header bar and menu drawer; 'all' has no entry, so it shows nothing.
  const BODY_LABELS = {
    pickup: 'PICKUP',
    CC: 'C&C',
    van: 'VAN',
  };

  const CHANGE_VEHICLE_ICON =
    'https://cdn.shopify.com/s/files/1/0712/1131/9389/files/swap-vehicles.png?v=1783466935';
  const ADD_VEHICLE_ICON =
    'https://cdn.shopify.com/s/files/1/0712/1131/9389/files/select-truck.png?v=1783540686';

  function getMakeLogo(make) {
    return MAKE_LOGOS[String(make || '').toLowerCase()] || DEFAULT_TRUCK_IMAGE;
  }

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  function formatEngineDisplay(engine) {
    return (
      window.TdVehicleStorage?.formatEngineDisplay(engine) ||
      String(engine || '').replace(/-/g, '.')
    );
  }

  function formatMakeLabel(make) {
    return MAKE_LABELS[make] || String(make || '').toUpperCase();
  }

  function formatSelectedVehicleLabel(vehicle) {
    if (!vehicle?.make) return '';

    const year = vehicle.year || '';
    const make = formatMakeLabel(vehicle.make);
    const engine = formatEngineDisplay(vehicle.engine);

    return `${year} ${make} ${engine}`.replace(/\s+/g, ' ').trim();
  }

  function formatVehicleLabelWithBody(vehicle) {
    const label = formatSelectedVehicleLabel(vehicle);
    if (!label) return '';

    const body = BODY_LABELS[vehicle.body] || '';

    return `${label} ${body}`.trim();
  }

  function updateMenuDrawerSearchByTruck() {
    const button = document.getElementById('menu-drawer-search-by-truck');
    const changeVehicle = document.getElementById('menu-drawer-change-vehicle');
    if (!button) return;

    const img = button.querySelector('[data-menu-drawer-truck-img]');
    const heading = button.querySelector('[data-menu-drawer-truck-heading]');
    const subtext = button.querySelector('[data-menu-drawer-truck-subtext]');
    const vehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;

    if (!vehicle?.make) {
      button.classList.remove('is-vehicle-selected');
      if (changeVehicle) changeVehicle.hidden = true;

      if (img) {
        img.src = DEFAULT_TRUCK_IMAGE;
        img.alt = 'Select your truck';
      }

      if (heading) {
        heading.innerHTML = '<strong>SELECT YOUR TRUCK</strong>';
      }

      if (subtext) {
        subtext.textContent = 'Find parts that fit your truck';
        subtext.hidden = false;
      }

      return;
    }

    const make = formatMakeLabel(vehicle.make);
    const label = `FIND ${formatVehicleLabelWithBody(vehicle)} PARTS`;

    button.classList.add('is-vehicle-selected');
    if (changeVehicle) changeVehicle.hidden = false;

    if (img) {
      img.src = getMakeLogo(vehicle.make);
      img.alt = `${make} logo`;
    }

    if (heading) {
      // textContent, because the body label "C&C" contains an ampersand.
      heading.innerHTML = '<strong></strong>';
      heading.firstChild.textContent = label;
    }

    if (subtext) {
      subtext.textContent = 'Find parts that fit your truck';
      subtext.hidden = false;
    }
  }

  function updateHeaderVehicleAdjust() {
    const container = document.querySelector('.header__vehicle-adjust');
    const changeButton = container?.querySelector('[data-header-change-vehicle]');
    const fitButton = container?.querySelector('[data-header-vehicle-fit]');
    const fitLabel = container?.querySelector('[data-header-vehicle-fit-label]');
    if (!container) return;

    const vehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;
    const hasVehicle = Boolean(vehicle?.make);

    if (changeButton) {
      const changeLabel = changeButton.querySelector('[data-header-change-vehicle-label]');
      const changeIcon = changeButton.querySelector('[data-header-change-vehicle-icon]');

      changeButton.hidden = false;

      if (hasVehicle) {
        if (changeLabel) changeLabel.textContent = 'Change vehicle';
        if (changeIcon) changeIcon.src = CHANGE_VEHICLE_ICON;
        changeButton.setAttribute('aria-label', 'Change vehicle');
      } else {
        if (changeLabel) changeLabel.textContent = 'Add Vehicle';
        if (changeIcon) changeIcon.src = ADD_VEHICLE_ICON;
        changeButton.setAttribute('aria-label', 'Add vehicle');
      }
    }

    if (fitButton) {
      fitButton.hidden = !hasVehicle;

      if (hasVehicle && fitLabel) {
        const label = formatVehicleLabelWithBody(vehicle);

        fitLabel.textContent = label;
        fitButton.setAttribute('aria-label', `Compatible with your ${label}`);
      } else if (fitLabel) {
        fitLabel.textContent = '';
        fitButton.setAttribute('aria-label', 'Compatible with your selected vehicle');
      }
    }

    const hasVisibleChild = [...container.children].some((child) => !child.hidden);
    container.hidden = !hasVisibleChild;
  }

  function updateProductVehicleCompatibility() {
    const hasVehicle = window.TdVehicleStorage?.hasSelectedVehicle?.() ?? false;
    const vehicle = hasVehicle ? window.TdVehicleStorage.getSelectedVehicle() : null;
    const label = formatSelectedVehicleLabel(vehicle);

    document.querySelectorAll('[data-td-selected-vehicle]').forEach((container) => {
      if (container.hasAttribute('data-yme-makes')) return;

      const fitLabel = container.querySelector('[data-header-vehicle-fit-label]');

      container.hidden = !hasVehicle;

      if (fitLabel && hasVehicle) {
        fitLabel.textContent = label;
      } else if (fitLabel) {
        fitLabel.textContent = '';
      }
    });
  }

  function updateMenuDrawerBuildKit() {
    const button = document.getElementById('menu-drawer-build-kit');
    if (!button) return;

    const headingEl = button.querySelector('[data-menu-drawer-build-kit-heading]');
    const vehicleEl = button.querySelector('[data-menu-drawer-build-kit-vehicle]');
    const vehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;
    const vehicleLabel = formatVehicleLabelWithBody(vehicle);
    const hasVehicle = Boolean(vehicleLabel);

    button.classList.toggle('is-vehicle-selected', hasVehicle);

    if (hasVehicle) {
      const heading = 'Build a custom kit for your';
      button.setAttribute('aria-label', `${heading} ${vehicleLabel}`);

      if (headingEl) {
        headingEl.innerHTML = `<strong>${heading}</strong>`;
      }

      if (vehicleEl) {
        vehicleEl.textContent = vehicleLabel;
        vehicleEl.hidden = false;
      }

      return;
    }

    button.setAttribute('aria-label', 'Build a custom kit');

    if (headingEl) {
      headingEl.innerHTML = '<strong>Build a custom kit</strong>';
    }

    if (vehicleEl) {
      vehicleEl.textContent = '';
      vehicleEl.hidden = true;
    }
  }

  function updateVehicleUi() {
    updateMenuDrawerSearchByTruck();
    updateMenuDrawerBuildKit();
    updateHeaderVehicleAdjust();
    updateProductVehicleCompatibility();
  }

  const HEADER_VEHICLE_SCROLL_HIDE_AT = 87;
  let hasSyncedHeaderVehicleScrollVisibility = false;

  function syncHeaderVehicleAdjustScrollVisibility() {
    const container = document.querySelector('.header__vehicle-adjust');
    if (!container) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldHide = scrollTop > HEADER_VEHICLE_SCROLL_HIDE_AT;

    if (!hasSyncedHeaderVehicleScrollVisibility) {
      container.classList.add('header__vehicle-adjust--no-transition');
      container.classList.toggle('header__vehicle-adjust--scrolled-away', shouldHide);
      requestAnimationFrame(() => {
        container.classList.remove('header__vehicle-adjust--no-transition');
        hasSyncedHeaderVehicleScrollVisibility = true;
      });
      return;
    }

    container.classList.toggle('header__vehicle-adjust--scrolled-away', shouldHide);
  }

  document.querySelectorAll('.header__search details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) scrollToTop();
    });
  });

  updateVehicleUi();
  syncHeaderVehicleAdjustScrollVisibility();
  window.addEventListener('scroll', syncHeaderVehicleAdjustScrollVisibility, { passive: true });
  window.addEventListener('td:vehicle-storage-change', updateVehicleUi);
  window.addEventListener('storage', (event) => {
    if (event.key === window.TdVehicleStorage?.STORAGE_KEY) {
      updateVehicleUi();
    }
  });

  function closeMenuDrawerIfOpen(event) {
    const headerDrawer = document.querySelector('header-drawer');
    const menuDetails = document.getElementById('Details-menu-drawer-container');
    const wasDrawerOpen = menuDetails?.hasAttribute('open');

    if (wasDrawerOpen && headerDrawer) {
      const menuSummary = menuDetails.querySelector('summary');
      headerDrawer.closeMenuDrawer(event, menuSummary);
    }

    return wasDrawerOpen;
  }

  const YME_RESULTS_URL = '/pages/year-make-product-search-results';

  function openVehiclePopupAfterDrawer(event) {
    const wasDrawerOpen = closeMenuDrawerIfOpen(event);

    const openVehiclePopup = () => {
      window.TdVehiclePopup?.open({ tab: 'new' });
    };

    if (wasDrawerOpen) {
      window.setTimeout(openVehiclePopup, 100);
    } else {
      openVehiclePopup();
    }
  }

  const searchByTruck = document.getElementById('menu-drawer-search-by-truck');
  if (searchByTruck) {
    searchByTruck.addEventListener('click', (event) => {
      event.preventDefault();
      const selectedVehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;

      if (selectedVehicle?.make) {
        closeMenuDrawerIfOpen(event);
        window.location.href = window.TdVehicleStorage?.getResultsUrl() || YME_RESULTS_URL;
        return;
      }

      openVehiclePopupAfterDrawer(event);
    });
  }

  const changeVehicle = document.getElementById('menu-drawer-change-vehicle');
  if (changeVehicle) {
    changeVehicle.addEventListener('click', (event) => {
      event.preventDefault();
      openVehiclePopupAfterDrawer(event);
    });
  }

  function openHeaderSearchModal(event) {
    const wasDrawerOpen = closeMenuDrawerIfOpen(event);

    const searchModal = document.querySelector('.header__icons .header__search');
    const searchSummary = searchModal?.querySelector('summary');

    if (!searchModal || !searchSummary) return;

    const focusSearchInput = () => {
      const searchInput = searchModal.querySelector(
        'input[type="search"], .search__input, input:not([type="hidden"])'
      );
      if (!searchInput) return;

      searchInput.focus({ preventScroll: true });

      if (typeof searchInput.setSelectionRange === 'function' && searchInput.value) {
        searchInput.setSelectionRange(0, searchInput.value.length);
      }
    };

    const openSearchModal = () => {
      if (!searchModal.isOpen?.()) {
        searchModal.open({ target: searchSummary });
      }

      // Mobile search is display:none until details[open]; focus after it becomes visible.
      requestAnimationFrame(() => {
        requestAnimationFrame(focusSearchInput);
      });
    };

    // Defer open so the initiating click does not immediately hit details-modal's
    // body click listener and close the modal. Drawer close needs a longer delay.
    window.setTimeout(openSearchModal, wasDrawerOpen ? 100 : 0);
  }

  const searchByPart = document.getElementById('menu-drawer-search-by-part');
  if (searchByPart) {
    searchByPart.addEventListener('click', (event) => {
      event.preventDefault();
      openHeaderSearchModal(event);
    });
  }

  const mobileTabsSearch = document.querySelector('#mobile-tabs [data-mobile-tabs-search]');
  if (mobileTabsSearch) {
    mobileTabsSearch.addEventListener('click', (event) => {
      event.preventDefault();
      openHeaderSearchModal(event);
    });
  }

  // MenuDrawer binds every summary inside header-drawer and traps focus in the panel
  // it opens, so keep shop-by-make clicks from reaching it and let details toggle natively.
  const shopByMake = document.getElementById('menu-drawer-shop-by-make');
  if (shopByMake) {
    shopByMake.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('[data-td-make-toggle]')) event.stopPropagation();
      },
      true
    );
  }
})();
